import { ONLINE_PREVIEW_LOGOUT } from '@lved/shared-core';
import { CommandContribution, CommandRegistry, MenuContribution, MenuModelRegistry } from '@theia/core';
import { MANAGE_MENU } from '@theia/core/lib/common/menu/menu-types';
import { inject, injectable } from '@theia/core/shared/inversify';
import { BrowserGitHubWorkspaceService } from './github-workspace-service';

export const GithubMenuCommands = {
    SYNC_FROM_GITHUB: { id: 'lvgl.onlinePreview.syncFromGitHub', label: 'Update from GitHub' },
    SIGN_OUT: { id: 'lvgl.onlinePreview.signOut', label: 'Sign out' }
} as const;

@injectable()
export class GithubMenuContribution implements CommandContribution, MenuContribution {
    @inject(BrowserGitHubWorkspaceService)
    protected readonly githubWorkspaceService!: BrowserGitHubWorkspaceService;

    registerCommands(commands: CommandRegistry): void {
        commands.registerCommand(GithubMenuCommands.SYNC_FROM_GITHUB, {
            execute: async (): Promise<void> => {
                await this.githubWorkspaceService.syncFromGitHub();
            }
        });
        commands.registerCommand(GithubMenuCommands.SIGN_OUT, {
            execute: (): void => {
                window.dispatchEvent(new CustomEvent(ONLINE_PREVIEW_LOGOUT));
            }
        });
    }

    registerMenus(menus: MenuModelRegistry): void {
        // Sign out stays command-only here — LicenseMenuContribution owns the Manage menu slot.
        menus.registerMenuAction(MANAGE_MENU, {
            commandId: GithubMenuCommands.SYNC_FROM_GITHUB.id,
            label: GithubMenuCommands.SYNC_FROM_GITHUB.label,
            order: '5'
        });
    }
}
